import { getApi } from '@/stores/api'
import { useQuery } from '@tanstack/react-query'

async function getFlaggedOutletSubtypes(signal?: AbortSignal) {
  const api = getApi()
  const res = await api.outlets.subtypes.flagged.$get({}, { init: { signal } })

  const subtypes = await res.json()
  return subtypes
}

async function getOutletSubtypes(signal?: AbortSignal) {
  const api = getApi()
  const res = await api.outlets.subtypes.$get({}, { init: { signal } })

  const subtypes = await res.json()
  return subtypes
}

export function useOutletSubtypes(
  type?: 'flagged',
  { enabled = true }: { enabled?: boolean } = {},
) {
  let options

  switch (type) {
    case 'flagged':
      options = {
        queryKey: ['flaggedOutletSubtypes'],
        queryFn: ({ signal }: { signal: AbortSignal }) => getFlaggedOutletSubtypes(signal),
      }
      break

    default:
      options = {
        queryKey: ['outletSubtypes'],
        queryFn: ({ signal }: { signal: AbortSignal }) => getOutletSubtypes(signal),
      }
      break
  }

  return useQuery({ ...options, enabled })
}
